import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-293adeea"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "扫码加入社群", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: "https://p6.moimg.net/md/qrcode/9FAEF501-94FF-434C-B2E7-343A1F2EAF9A.png"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $options.showEWM,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $options.showEWM = $event),
    "close-on-click-overlay": false,
    class: "popup-box"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = $event => $options.showEWM = false)
    }), _hoisted_2])]),
    _: 1
  }, 8, ["show"]);
}